import React from 'react';
import { Navigate } from 'react-router-dom';
import useAdminAuth from '../../Hooks/useAdminAuth';
import TopBar from '../TopBar/TopBar';

const AdminRoute = ({ children }) => {
    const isAdmin = useAdminAuth()
    return isAdmin ? <>
        <TopBar></TopBar>
        {children}
    </> : <Navigate to='/admin'></Navigate>

};

export default AdminRoute;